import { render, staticRenderFns } from "./expire.vue?vue&type=template&id=0ef77df4&scoped=true"
import script from "./expire.vue?vue&type=script&lang=js"
export * from "./expire.vue?vue&type=script&lang=js"
import style0 from "./expire.vue?vue&type=style&index=0&id=0ef77df4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef77df4",
  null
  
)

export default component.exports